import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useTranslate } from '@/hooks/useTranslate';

const EULA_URL = 'https://appcharge.com/end-user-license-agreement';
const PRIVACY_POLICY_URL = 'https://appcharge.com/payments-privacy-policy/';

const openNewTab = (url: string) => window.open(url, '_blank', 'noopener,noreferrer');

/**
 * Subscriptions-only legal line (ACDEV-26078, ported from independent-checkout-v2's
 * `SubscriptionAgreement`): "By purchasing you agree to the Appcharge 'EULA' and
 * 'Privacy Policy'". The generic `ApprovalText` is driven by backend footer text,
 * which subscriptions never populate, so this hardcoded line covers the same
 * legal disclosure for that route. Renders null off the subscription route.
 */
export const SubscriptionAgreement = () => {
  const { subscription } = useContext(CheckoutContext);
  const { t } = useTranslate();

  if (!subscription) return null;

  return (
    <div
      data-testid="subscription-agreement-disclaimer"
      className="w-full text-center text-[10px] leading-4 text-muted-foreground"
    >
      {t('subscriptionAgreementPrefix')}{' '}
      <span className="cursor-pointer" onClick={() => openNewTab(EULA_URL)}>
        '{t('endUserLicenseAgreement')}'
      </span>{' '}
      {t('and')}{' '}
      <span className="cursor-pointer" onClick={() => openNewTab(PRIVACY_POLICY_URL)}>
        '{t('privacyPolicy')}'
      </span>
    </div>
  );
};
